module.exports = __webpack_public_path__ + "img/register-v2.62052e63.svg";